import Image from 'next/image'
import { useState } from 'react'

import { Button } from '@wartek-id/button-v1'
import { Checkbox } from '@wartek-id/checkbox-v1'
import type { DialogProps } from '@wartek-id/dialog-v1'
import { Dialog, DialogContent, DialogOverlay } from '@wartek-id/dialog-v1'
import { Text } from '@wartek-id/text-v1'

interface DialogConfirmEditProps extends Omit<DialogProps, 'children'> {
  onConfirm?: () => void
}

export default function DialogConfirmEdit({
  onConfirm = () => {},
  ...props
}: DialogConfirmEditProps) {
  const [isConfirmEditRHK, setIsConfirmEditRHK] = useState(false)

  return (
    <Dialog {...props}>
      <DialogOverlay />

      <DialogContent>
        <div className="px-6 py-8 flex flex-col gap-4">
          <div className="w-[84px] h-[84px] relative">
            {/* Prevent user select */}
            <div className="absolute inset-0 z-10">&nbsp;</div>

            <Image
              alt=""
              src={'/illustrations/img-chat-talk.png'}
              width={84}
              height={84}
            />
          </div>

          <Text variant="display-sm">
            Pastikan Anda sudah berdiskusi dengan atasan sebelum mengubah
            rencana
          </Text>

          <Text variant="body-lg" color="subdued" className="!text-[20px]">
            Agar rencana tetap sesuai dengan ekspektasi atasan.
          </Text>

          <Checkbox
            checked={isConfirmEditRHK}
            onChange={(e) => setIsConfirmEditRHK(e.target.checked)}
          >
            Saya menyatakan bahwa saya sudah berdiskusi dengan atasan sebelum
            mengubah rencana.
          </Checkbox>

          <div className="flex gap-5">
            <Button size="lg" color="white" onClick={() => props.onClose?.()}>
              Batal
            </Button>
            <Button
              size="lg"
              disabled={!isConfirmEditRHK}
              onClick={() => {
                props.onClose?.()
                onConfirm()
              }}
            >
              Saya sudah diskusi
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
